import { DoFinalCheckStepCtrl } from './do-final-check.controller';

export const DoFinalCheckStepComponent = {
  controller: DoFinalCheckStepCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
    currentCourseDiffs: '<',
  },
  template: require('./do-final-check.html'),
};
